<template>
  <div>
    <!-- Doc Upload -->
    <b-modal
      id="add-visa-doc-modal"
      ref="visa-doc-upload-modal"
      centered
      title="Upload Document"
      ok-title="Submit"
      @show="resetAddDocModal"
      @hidden="resetAddDocModal"
      @ok="documentUpload"
    >
      <br />
      <b-form-select class="form-group" v-model="document_type">
        <b-form-select-option
          v-for="(item, index) in $store.getters['home/getVisaDocumentTypes']"
          :key="'vdoc_types_' + index"
          :value="item.vdoc_id"
        >
          {{ item.vdoc_name }}
        </b-form-select-option>
      </b-form-select>
      <br />
      <b-form-input
        v-if="document_type === 30"
        v-model="document_extra_label"
        placeholder="Enter Document Name"
      />
      <br />
      <br />
      <b-form-file
        class="form-group"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
        v-model="document_file"
      ></b-form-file>
      <br />
    </b-modal>

    <!-- Doc Remove -->
    <b-modal
      id="remove-visa-doc-modal"
      ref="visa-doc-remove-modal"
      centered
      title="Remove Document"
      ok-title="Remove"
      @hidden="resetRemoveDocId"
      @ok="removeDoc"
    >
      {{ doc_to_remove ? doc_to_remove.vdoc_name : "" }}
    </b-modal>

    <b-card>
      <b-tabs>
        <b-tab title="Upload Visa Documents">
          <div class="custom-search d-flex justify-content-end">
            <div class="demo-inline-spacing">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.add-visa-doc-modal
                variant="outline-primary"
              >
                Add document
              </b-button>
            </div>
          </div>
          <br />

          <vue-good-table
            :columns="columns"
            :rows="document_list"
            :rtl="direction"
          >
            <template slot="table-row" slot-scope="props">
              <span
                v-if="props.column.field === 'vdoc_name'"
                class="text-wrap text-uppercase"
              >
                {{ props.row.vdoc_name }}
                {{
                  props.row.vdoc_id === 30 && props.row.extra_label
                    ? ` - ${props.row.extra_label}`
                    : ""
                }}
              </span>
              <span v-if="props.column.field === 'open'" class="text-nowrap">
                <div
                  @click="(e) => openDoc(e, props)"
                  class="text-center"
                  role="button"
                >
                  <b-avatar variant="light-success" size="30">
                    <feather-icon
                      icon="EyeIcon"
                      size="15"
                      class="text-success"
                    />
                  </b-avatar>
                </div>
              </span>
              <span
                v-if="props.column.field === 'remove_doc'"
                class="text-nowrap"
              >
                <div
                  v-if="props.row.doc_approved !== 'approved'"
                  @click="setDocIdToRemove(props.row)"
                  class="text-center"
                  role="button"
                >
                  <b-avatar variant="light-danger" size="30">
                    <feather-icon
                      icon="TrashIcon"
                      size="15"
                      class="text-danger"
                    />
                  </b-avatar>
                </div>
                <div v-else></div>
              </span>
              <span
                v-if="props.column.field === 'doc_approved'"
                class="text-nowrap text-capitalize"
              >
                <b-badge variant="light-danger">
                  {{ props.row.doc_approved }}
                </b-badge>
              </span>
              <span
                v-else-if="props.column.field === 'created_at'"
                class="text-nowrap"
              >
                {{ getFormattedDate(props.row.created_at) }}
              </span>
              <span
                v-else-if="props.column.field === 'comments_mentioned'"
                class="text-nowrap"
              >
                {{ props.row.extra_text }}
              </span>
            </template>
          </vue-good-table>
        </b-tab>
        <b-tab title="Visa Checklist">
          <visa-checklist />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  VBModal,
  BAlert,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BFormSelectOption,
  BCard,
  BTab,
  BTabs,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import ToastificationContentVue from "@/@core/components/toastification/ToastificationContent.vue";
import StudentServices from "@/apiServices/StudentServices";
import Ripple from "vue-ripple-directive";
import { BASEURL, FILESURL } from "@/config/index";
import axios from "axios";
import { TokenService } from "@/apiServices/storageService";
import helpers from "@/libs/helpers";
import VisaChecklist from "./VisaCheckList.vue";

export default {
  components: {
    VueGoodTable,
    BFormFile,
    BModal,
    BButton,
    VBModal,
    BAlert,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormSelectOption,
    BCard,
    BTab,
    BTabs,
    VisaChecklist,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      doc_to_remove: null,
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Type of document",
          field: "vdoc_name",
        },
        {
          label: "Preview",
          field: "open",
        },
        {
          label: "Approvel Status",
          field: "doc_approved",
        },
        {
          label: "Comments Mentioned",
          field: "comments_mentioned",
        },
        {
          label: "Uploaded Date",
          field: "created_at",
        },
        {
          label: "Delete",
          field: "remove_doc",
        },
      ],
      searchTerm: "",
      document_list: [],
      document_type: null,
      document_file: null,
      document_extra_label: null,
    };
  },
  computed: {
    // studentDocType() {
    //   let StudentDocTypes = [];
    //   store.getters["home/getDocumentTypes"];

    // },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  methods: {
    getFormattedDate: helpers.getDateTimeFormatted,
    resetAddDocModal() {
      this.document_file = null;
      this.document_type = null;
    },
    resetRemoveDocId() {
      this.doc_to_remove = null;
    },
    setDocIdToRemove(doc) {
      this.$refs["visa-doc-remove-modal"].show();
      this.doc_to_remove = doc;
    },
    openDoc(e, prop) {
      const url = FILESURL + prop.row.vdoc_url;
      window.open(url);
    },
    removeDoc() {
      const svd_id = this.doc_to_remove.svd_id;
      StudentServices.RemoveVisaDocument({ svd_id })
        .then((response) => {
          if (response.data.status) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: "Document Removed",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.getAllDocuments();
          } else {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "Document Remove Failed",
                icon: "EditIcon",
                variant: "failure",
              },
            });
          }
        })
        .catch((err) => {
          console.log("Error removing document ", err);
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Server Error",
              icon: "EditIcon",
              variant: "failure",
            },
          });
          this.$nextTick(() => {
            this.$refs["visa-doc-remove-modal"].toggle("#toggle-btn");
          });
        });
      this.getAllDocuments();
    },
    async documentUpload(e) {
      e.preventDefault();

      if (!this.document_file) {
        helpers.showErrorToast(this, "Please Upload Document");
        return;
      }

      const format = /[^\x00-\x7F]/;
      if (format.test(this.document_file.name)) {
        helpers.showErrorToast(
          this,
          "Filename cannot contain special characters"
        );
        return;
      }

      if (this.document_file.size > 10 * 1024 * 1024) {
        helpers.showErrorToast(this, "Filesize cannot be greater than 5MB");
        return;
      }

      if (!this.document_type) {
        helpers.showErrorToast(this, "Select Document Type");
        return;
      }

      if (this.document_type === 30 && !this.document_extra_label) {
        helpers.showErrorToast(this, "Enter Document Name");
        return;
      }

      const document_extra_label = this.document_extra_label;
      this.document_extra_label = null;

      try {
        const AUTH_TOKEN = TokenService.getToken();

        const formData = new FormData();
        formData.append("doc", this.document_file);

        const response = await axios.post(
          `${BASEURL}/student/visa-document/upload/${this.document_type}`,
          formData,
          {
            headers: {
              "content-type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              authorization: AUTH_TOKEN,
            },
            params: {
              document_extra_label,
            },
          }
        );

        if (response.data.status) {
          this.getAllDocuments();
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Document Uploaded Successfully",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$nextTick(() => {
            this.$refs["visa-doc-upload-modal"].toggle("#toggle-btn");
          });
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Document Uploaded Failed",
              icon: "EditIcon",
              variant: "failure",
            },
          });
        }
      } catch (err) {
        console.log("Error uploading file ", err);
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: "Server Error",
            icon: "EditIcon",
            variant: "failure",
          },
        });
      }
    },
    getAllDocuments() {
      StudentServices.getAllVisaDocuments()
        .then((response) => {
          if (response.data.status) {
            this.document_list = response.data.data;
          } else {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title:
                  response.data.message || "Server Error Getting Documents",
                icon: "EditIcon",
                variant: "failure",
              },
            });
          }
        })
        .catch((err) => {
          console.log("Error getting documents ", err);
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Server Error Getting Documents",
              icon: "EditIcon",
              variant: "failure",
            },
          });
        });
    },
  },
  beforeMount() {
    this.getAllDocuments();
    this.$store.dispatch("home/onGetVisaDocumentTypes");
  },
};
</script>


<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

